'use strict';

var ConfigurationLinkedFbcDirective = function ConfigurationLinkedFbcDirective() {
  return {
    restrict: 'E',
    controller: 'ConfigurationLinkedFbcController',
    template: require('../templates/configuration-linked-fbc.html'),
    link: function link($scope, element) {
      $scope.isValidationMessage = function () {
        var validationMessageCssDisplay = element.find('.jqx-grid-validation').css('display');
        return validationMessageCssDisplay && validationMessageCssDisplay !== 'none';
      };
    }
  };
};
ConfigurationLinkedFbcDirective.$inject = [];
module.exports = ConfigurationLinkedFbcDirective;